import { useQuestionnaireAnswersState } from "../contact-form/utils/questionnaireStorage";
import { CheckCircle2, XCircle, AlertCircle, InfoIcon, GitBranch } from "lucide-react";

export function QuestionnaireAnswersToSubmitTab() {
  const [questionAnswers] = useQuestionnaireAnswersState();

  // Check if this is multi-study data
  const hasMultiStudyData = !!(questionAnswers.matchedStudyId || questionAnswers.matchedStudyTrialId);

  return (
    <div className="p-4">
      <h3 className="text-sm font-medium mb-3">Questionnaire Data Preview</h3>

      {/* Status indicator */}
      <div className="mb-4 border rounded-md overflow-hidden">
        <div className="bg-gray-50 px-3 py-2 border-b text-xs font-medium">
          Prescreening Status
        </div>

        <div className="p-3">
          {!questionAnswers.prescreeningStatus && (
            <div className="flex items-center">
              <AlertCircle size={16} className="text-gray-500" />
              <span className="ml-2 text-sm">Not completed</span>
            </div>
          )}

          {questionAnswers.prescreeningStatus === "passed" && (
            <div className="flex items-center">
              <CheckCircle2 size={16} className="text-green-600" />
              <span className="ml-2 text-sm text-green-700">Passed</span>
            </div>
          )}

          {questionAnswers.prescreeningStatus === "failed" && (
            <div>
              <div className="flex items-center">
                <XCircle size={16} className="text-red-600" />
                <span className="ml-2 text-sm text-red-700">Failed</span>
              </div>

              <div className="mt-2 bg-gray-50 p-2 rounded flex items-start border border-gray-200">
                <InfoIcon size={14} className="text-blue-500 mt-0.5" />
                <span className="ml-2 text-xs text-gray-700">
                  Contact details will still be submitted, but the trial ID will
                  be removed.
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Multi-Study Match Highlight */}
      {hasMultiStudyData && (
        <div className="mb-4 border border-purple-200 bg-purple-50 rounded-md overflow-hidden">
          <div className="bg-purple-100 px-3 py-2 border-b border-purple-200 flex items-center">
            <GitBranch size={14} className="text-purple-600 mr-2" />
            <span className="text-xs font-medium text-purple-700">
              Multi-Study Match
            </span>
          </div>

          <div className="p-3 space-y-2">
            {questionAnswers.matchedStudyId && (
              <div className="text-xs">
                <span className="font-medium text-purple-700">Matched Study:</span>{" "}
                <span className="font-mono text-purple-900 bg-purple-100 px-1.5 py-0.5 rounded">
                  {questionAnswers.matchedStudyId}
                </span>
              </div>
            )}

            {questionAnswers.matchedStudyTrialId && (
              <div className="text-xs">
                <span className="font-medium text-purple-700">Trial ID:</span>{" "}
                <span className="font-mono text-purple-900 bg-purple-100 px-1.5 py-0.5 rounded">
                  {questionAnswers.matchedStudyTrialId}
                </span>
              </div>
            )}

            <div className="mt-2 bg-white p-2 rounded flex items-start border border-purple-200">
              <InfoIcon size={14} className="text-purple-500 mt-0.5 flex-shrink-0" />
              <span className="ml-2 text-xs text-purple-700">
                See the <strong>Matching</strong> tab for detailed study matching information
              </span>
            </div>
          </div>
        </div>
      )}

      {questionAnswers?.questionAnswers ? (
        <div className="border rounded-md overflow-hidden">
          <div className="bg-gray-50 px-3 py-2 border-b text-xs font-medium">
            JSON Data
          </div>
          <pre className="bg-white p-3 text-xs overflow-auto">
            {JSON.stringify(questionAnswers, null, 2)}
          </pre>
        </div>
      ) : (
        <div className="text-center py-6 bg-gray-50 border rounded-md text-sm text-gray-500">
          No submission data available yet
        </div>
      )}
    </div>
  );
}
